import type { Components, Theme } from '@mui/material';

import { colors } from '../tokens';

export const MuiSvgIcon: Components<Theme>['MuiSvgIcon'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      color: colors.gray[400],
      fontSize: theme.typography.pxToRem(20),
      '.MuiRadio-root &, .MuiCheckbox-root &': {
        color: 'inherit',
      },
      ...theme.applyStyles('dark', {
        color: colors.black[200],
        '.MuiRadio-root &, .MuiCheckbox-root &': {
          color: 'inherit',
        },
      }),
    }),
  },
};
